import { useState } from 'react';
import { Paperclip, Upload } from 'lucide-react';
import { useEntityAttachments } from '../../hooks/useEntityAttachments';
import { EntityModal } from '../common/EntityModal';
import { EntityAttachmentSection } from './EntityAttachmentSection';

interface AttachmentButtonProps {
  entityType: string;
  entityId: string;
  /** Icon size in px (default 14) */
  size?: number;
  title?: string;
}

export function AttachmentButton({
  entityType,
  entityId,
  size = 14,
  title,
}: AttachmentButtonProps) {
  const { data: attachments = [] } = useEntityAttachments(entityType, entityId);
  const [open, setOpen] = useState(false);

  const count = attachments.length;
  const tooltip =
    title ?? (count > 0 ? `${count} attachment${count !== 1 ? 's' : ''}` : 'Add attachment');

  return (
    <>
      <button
        onClick={(e) => {
          e.stopPropagation();
          setOpen(true);
        }}
        title={tooltip}
        className="relative p-1 text-gray-400 hover:text-primary-600 transition-colors"
      >
        {count > 0 ? (
          <>
            <Paperclip size={size} className="text-primary-600" />
            <span className="absolute -top-0.5 -right-0.5 min-w-[14px] h-3.5 px-0.5 text-[9px] font-bold bg-primary-600 text-white rounded-full flex items-center justify-center">
              {count}
            </span>
          </>
        ) : (
          <Upload size={size} />
        )}
      </button>

      <EntityModal open={open} onClose={() => setOpen(false)} title="Attachments" size="md">
        <EntityAttachmentSection entityType={entityType} entityId={entityId} />
      </EntityModal>
    </>
  );
}
